<template>
  <div class="footer">
    <div class="menus">
      <div
        class="menu-item"
        v-for="(item, index) in menus"
        :key="`menu-item${index + 1}`"
        @click="goPath(item.path)"
      >
        {{ item.text }}
      </div>
    </div>
    <div class="codes">
      <div
        class="code-item"
        v-for="(item, index) in codes"
        :key="`code-item${index + 1}`"
      >
        <img :src="item.icon" :alt="item.text" class="img" />
        <span class="text">{{ item.text }}</span>
      </div>
    </div>
    <div class="putOnFile">
      <div>沪ICP备09008869号-1</div>
      <div>
        <img :src="policenet" alt="" />
        <span>沪公网安备 31011002000007号</span>
      </div>
    </div>
    <div class="copyright">©Copyright 2002 - 2022 UniDT(shanghai) Co.,Ltd.</div>
  </div>
</template>
<script>
import icon_wb from "@/../static/img/home/wb.png";
import icon_wx from "@/../static/img/home/wx.png";
import policenet from "@/../static/img/home/policenet.png";
export default {
  data() {
    return {
      policenet,
      menus: [
        { text: "站点地图", path: "/siteMap" },
        { text: "联系我们", path: "/about?tab=3" },
        { text: "法律声明", path: "/legalNotice" },
        { text: "合作伙伴", path: "/partner" }
      ],
      codes: [
        { text: "微信公众号", icon: icon_wx },
        // { text: "官方微博", icon: icon_wb }
      ]
    };
  },
  methods: {
    goPath(path) {
      this.$router.push(path);
    }
  }
};
</script>
<style lang="less" scoped>
.footer {
  height: 476px;
  width: calc(100% - 40px);
  background: #16243d;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  .menus {
    display: flex;
    justify-content: space-around;
    .menu-item {
      font-size: 24px;
      font-weight: 400;
      color: #9ea2c1;
      line-height: 76px;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .codes {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
    .code-item {
      height: 172px;
      margin: 0 36px;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-items: center;
      .img {
        width: 96px;
        height: 96px;
      }
      .text {
        height: 76px;
        font-size: 24px;
        font-weight: 400;
        color: #9ea2c1;
        line-height: 76px;
      }
    }
  }
  .putOnFile {
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-size: 24px;
      font-weight: 500;
      color: #9ea2c1;
      line-height: 76px;
      display: flex;
      align-items: center;
      > img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
    }
  }
  .copyright {
    font-size: 24px;
    text-align: center;
    font-weight: 500;
    color: #9ea2c1;
    line-height: 32px;
    margin-bottom: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue